import { formToMutation } from './formToMutation';
import { queryToForm } from './queryToForm';

export default { formToMutation, queryToForm };
